import { render } from "./EditorPanel.vue?vue&type=template&id=046b0711&scoped=true"
import script from "./EditorPanel.vue?vue&type=script&lang=js"
export * from "./EditorPanel.vue?vue&type=script&lang=js"

import "./EditorPanel.vue?vue&type=style&index=0&id=046b0711&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046b0711"]])

export default __exports__